import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'ml-confirm-dialog',
  template: `
    <div class="confirm-dialog" fxLayout="column" fxLayoutAlign="space-between">
      <div class="mat-title">{{ 'confirm' | translate | titlecase }}</div>
      <div class="mat-subheading-2 confirm-dialog-subtitle">
        {{ data.title | translate: data.interpolateParams | sentancecase }}
      </div>

      <ml-dialog-actions
        [buttonRight]="'yes'"
        (clickLeft)="onCancel()"
        (clickRight)="onConfirm()"
      ></ml-dialog-actions>
    </div>
  `,
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      interpolateParams: { [name: string]: string };
    }
  ) {}

  ngOnInit() {}

  onCancel() {
    this.dialogRef.close(false);
  }

  onConfirm() {
    this.dialogRef.close(true);
  }
}
